import React from 'react';
import { convertNodeToElement } from 'react-html-parser';
import { v4 as uuidv4 } from 'uuid';

import {
  AccessibleLinkDescription,
  isExternalLink,
  Button as RKSButton,
  TableRender,
  WysiwygField as RKSWysiwygField,
} from '@uncinc/uncinc-react-kitchen-sink';

import './style.scss';

export const customElementHandler = (node) => {
  const accessibleLinkDescriptionId = `accessible-link-description-${uuidv4()}`;

  switch (node.name) {
    case 'table': {
      return (
        <TableRender tabIndex="0" element={convertNodeToElement(node)} mobileCards {...node.attribs} />
      );
    }
    case 'a': {
      if (node.attribs.class && node.attribs.class.includes('button--primary')) {
        const label = node.children[0].data;
        return (
          <RKSButton
            primary
            withIcon
            buttonIcon
            href={node.attribs.href}
            target={node.attribs.target || ''}
            rel={node.attribs.target ? 'noopener' : ''}
            key={`${node.name}:${label}`}
          >
            {label}
          </RKSButton>
        );
      } else if (isExternalLink(node.attribs.href)) {
        const label = node.children[0].data;

        return (
          <>
            <a
              {...node.attribs}
              href={node.attribs.href}
              target={node.attribs.target || '_blank'}
              rel={node.attribs.target ? 'noreferrer noopener' : ''}
              aria-describedby={accessibleLinkDescriptionId}
            >
              {label}
            </a>
            <AccessibleLinkDescription id={accessibleLinkDescriptionId} />
          </>
        );
      }
      break;
    }
    default: {
      return null;
    }
  }
};

const WysiwygField = (props) => {
  return (
    <RKSWysiwygField
      customElementHandler={customElementHandler}
      {...props}
    />
  );
};

export default WysiwygField;
